import React, { FC } from 'react'
import { SessionId } from '@afterpaytouch/identity'
import { useFlag } from '@afterpaytouch/feature'
import { useSessionId } from '../../state'
import { useAmplitude } from 'react-amplitude-hooks'
import { useTranslation } from 'next-i18next'
import { Features, SessionIdVisibility } from '../../model'
import styles from './SessionIdContainer.module.css'

export const SessionIdContainer: FC = () => {
  const { t } = useTranslation()
  const { visibility } = useSessionId()
  const isFeatureEnabled = useFlag(Features.ENABLE_CHECKOUT_ERROR_SESSION_IDENTIFIER)
  const { amplitudeInstance } = useAmplitude()

  const isVisible = isFeatureEnabled && visibility === SessionIdVisibility.VISIBLE
  const rawSessionId = amplitudeInstance?.getSessionId()?.toString() ?? ''

  // Container handles translation - component just displays
  const formattedSessionId = t('common:sessionId', { sessionId: rawSessionId })

  return <SessionId sessionId={formattedSessionId} isVisible={isVisible} className={styles.text} />
}
